import React from 'react';
import Lottie from 'lottie-react';
import { Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import loginBg from 'src/assets/login-bg.svg';
import logoLottie from 'src/assets/logo-lottie.json';
import Icon from 'src/components/common/Icon';
import { ROOT } from 'src/constants/routes';
import { useAppSelector } from 'src/hooks/store';
import { useTranslation } from 'src/hooks/translations';
import { selectAuth } from 'src/store/user/selectors';
import prayerStats from 'src/utils/stats';

import GoogleProvider from './GoogleProvider';
import css from './Login.module.scss';
import { DispatchContext, StateContext, initialState, reducer } from './state';

export default function Login() {
  const { translate: _t } = useTranslation('login');
  const navigate = useNavigate();
  const auth = useAppSelector(selectAuth);
  const location = useLocation();
  const redirectTo = location.state?.from || ROOT;

  const [state, authDispatch] = React.useReducer(reducer, {
    ...initialState,
    authType: 'sign-in',
    currentView: 'default',
  });

  if (auth.isLoggedIn) {
    return <Navigate to={redirectTo} replace />;
  }

  const onGoogleLoginClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    authDispatch({ type: 'setCurrentView', payload: 'googleProvider' });
  };

  return (
    <div className={css.login} style={{ backgroundImage: `url(${loginBg})` }}>
      <div className={css.content}>
        <Lottie animationData={logoLottie} loop autoplay />
        <h1 className={css.title}>{_t('title')}</h1>
        <p className={css.subTitle}>{_t('subText')}</p>
        <StateContext.Provider value={state || null}>
          <DispatchContext.Provider value={authDispatch}>
            <button type="button" className={css.loginGoogleBtn} onClick={onGoogleLoginClick}>
              <Icon type="google" />
              <span>{_t('googleBtn')}</span>
            </button>

            {state?.currentView === 'googleProvider' && (
              <GoogleProvider
                action={state.authType}
                onSuccess={() => {
                  navigate(redirectTo, { replace: true });
                }}
              />
            )}
            <div className={css.guestBtn} onClick={() => navigate(-1)}>
              {_t('guestBtn')}
            </div>
          </DispatchContext.Provider>
        </StateContext.Provider>
      </div>
    </div>
  );
}
